import { LogLevel } from 'angular-auth-oidc-client';
import {URL_PAGE} from "../app/shared/enums/url.pages.enum";
import version from './../../package.json';
export const environment = {
  version: version.version,
  env: 'PROD',
  production: true,
  byPassI2a: false,
  bandeau_script: 'https://www.portail-bscc.extra.laposte.fr/dist/js/bandeau.min.js',
  bff_affectation_server: 'https://apim-gw.extra.laposte.fr/despatchRoutingServices/v1',
  bff_appairage_server: 'https://apim-gw.extra.laposte.fr/despatchConsignServices/v1',
  bff_recap_server: 'https://apim-gw.extra.laposte.fr/exportConsignmentServices/v1',
  apim_env: 'prod',

  authentification: {
    oidc: {
      authority: 'https://oidc.net-courrier.extra.laposte.fr',
      authWellknownEndpointUrl: 'https://oidc.net-courrier.extra.laposte.fr/oauth2/v1/metadata/oidc_spa_default/',
      redirectUrl: window.location.origin,
      clientId: 'dz_-u51-001-prd.web.laposte.fr',
      responseType: 'code',
      scope: 'openid profile role',
      postLogoutRedirectUri: window.location.origin,
      silentRenew: true,
      silentRenewUrl: `${ window.location.origin }/silent-renew.html`,
      unauthorizedRoute: '/' + URL_PAGE.UNAUTHORIZED,
      autoUserInfo: false,
      disableIatOffsetValidation: true,
      renewTimeBeforeTokenExpiresInSeconds: 1800,
      triggerAuthorizationResultEvent: true
    },
    apim: {
      issuer: 'https://apim-gw.extra.laposte.fr/token',
      clientId: 'f1hrypk95t5e5c74fjRfIDvNhoca',
      grantType: 'urn:ietf:params:oauth:grant-type:jwt-bearer',
      scope: 'openid i2a',
      silentRenew: true
    },
    logLevel: LogLevel.Error
  }
};
